import { destroy, submit, reset } from 'redux-form';

export const destroyForm = formName => {
  return destroy(formName);
};

export const submitForm = formName => {
  return submit(formName);
};

export const resetForm = formName => {
  return reset(formName);
};



// WEBPACK FOOTER //
// ./src/state/forms/actions.js